import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Box from '@material-ui/core/Box'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import { Link as RouterLink } from 'react-router-dom'
import ChevronRightIcon from 'components/material-symbol/icons/ChevronRight'
import OpenInNewIcon from 'components/material-symbol/icons/OpenInNew'
import useStyles from './styles'

const AccountLinkRow = ({
  href,
  to,
  onClick,
  icon,
  title,
  description,
  disabled,
}) => {
  const classes = useStyles()
  const TrailingIcon = href && !disabled ? OpenInNewIcon : ChevronRightIcon
  const normalizedIcon = React.isValidElement(icon)
    ? React.cloneElement(icon, { fontSize: 24 })
    : icon
  const content = (
    <>
      <Box className={classes.iconWrap}>{normalizedIcon}</Box>
      <Box className={classes.copy}>
        <Typography className={classes.title}>{title}</Typography>
        {description ? (
          <Typography className={classes.caption}>{description}</Typography>
        ) : null}
      </Box>
      <TrailingIcon className={classes.chevron} />
    </>
  )

  if (disabled) {
    return (
      <Box
        component="button"
        type="button"
        disabled
        className={clsx(classes.link, classes.button, classes.disabled)}
      >
        {content}
      </Box>
    )
  }

  if (to) {
    return (
      <RouterLink to={to} className={classes.link}>
        {content}
      </RouterLink>
    )
  }

  if (href) {
    return (
      <Link
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        underline="none"
        className={classes.link}
      >
        {content}
      </Link>
    )
  }

  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      className={clsx(classes.link, classes.button)}
    >
      {content}
    </Box>
  )
}

AccountLinkRow.propTypes = {
  href: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  disabled: PropTypes.bool,
}

export default AccountLinkRow
